<template>
  <b-list-group-item class="py-1 px-0 d-flex align-items-center">
    <b-skeleton
      v-if="showFCPToggle"
      width="52px"
      height="24px"
      class="mr-2"
      style="border-radius: 20px"
    />
    <b-skeleton
      width="52px"
      height="24px"
      class="mr-2"
      style="border-radius: 20px"
    />

    <b-skeleton width="50%" height="18px" />
  </b-list-group-item>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { useCurrentUser } from '@composables'

export default defineComponent({
  name: 'BDXStatusModalItemSkeleton',
  setup() {
    const { fcpRole } = useCurrentUser()

    const showFCPToggle = computed(
      () => fcpRole.value && 'User' !== fcpRole.value
    )

    return {
      showFCPToggle
    }
  }
})
</script>
